const React = require('react');
const injectI18n = require('nordic/i18n/injectI18n');

const SidebarEmpty = () => <div className="sidebar-container slideout-menu slideout-menu-left slidemobile-menu" />;

module.exports = injectI18n(SidebarEmpty);
